import React, { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

/** The app's BrowserRouter, with navigation rendered synchronously rather than as a React transition. */
const AppRouter = ({ children }: { children: ReactNode }) => (
  <BrowserRouter useTransitions={false}>{children}</BrowserRouter>
);

export default AppRouter;
